function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "h",
  d: "M74.735 23.269c-.574-1.463-1.905-3.525-3.789-4.975-1.09-.836-2.389-1.638-4.173-2.167-1.902-.564-4.244-.754-7.16-.754H32.949c-2.916 0-5.258.19-7.16.754-1.786.529-3.085 1.331-4.173 2.167-1.884 1.453-3.212 3.511-3.789 4.975-1.162 2.948-1.172 6.292-1.172 8.399v26.664c0 2.106.013 5.451 1.172 8.399.574 1.463 1.905 3.525 3.789 4.975 1.09.836 2.389 1.638 4.173 2.167 1.902.564 4.244.754 7.16.754h26.664c2.916 0 5.258-.19 7.16-.754 1.786-.529 3.085-1.328 4.173-2.167 1.884-1.453 3.212-3.511 3.789-4.975 1.162-2.948 1.172-6.292 1.172-8.399V31.668c0-2.106-.013-5.451-1.172-8.399z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "g"
}, /*#__PURE__*/React.createElement("use", {
  overflow: "visible",
  xlinkHref: "#h"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#g)"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 46.281,
  x2: 46.281,
  y1: 74.626,
  y2: 15.373,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ff7632",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ff9934",
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.654 15.373h59.253v59.253H16.654z",
  fill: "url(#f)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 46.281,
  x2: 46.281,
  y1: 68.701,
  y2: 21.299,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#292e3c",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#484f5c",
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M46.281 68.701C33.146 68.701 22.58 58.135 22.58 45s10.567-23.701 23.701-23.701S69.982 31.865 69.982 45 59.416 68.701 46.281 68.701zm0-9.381l1.778-1.778-1.778-6.814-1.778 6.814 1.778 1.778zm-2.271-.099l-.889 3.358 2.074-2.074-1.185-1.284zm4.542 0l-1.185 1.185 2.074 2.074-.889-3.259zm1.679 6.122l-3.95-3.95-3.95 3.95c1.284.198 2.568.395 3.95.395 1.382.001 2.666-.098 3.95-.395zm-3.95-41.082c-11.455 0-20.739 9.283-20.739 20.739 0 9.085 5.826 16.788 13.924 19.553l4.444-16.492c-.988-.691-1.58-1.877-1.58-3.161a3.962 3.962 0 0 1 3.95-3.95 3.962 3.962 0 0 1 3.95 3.95c0 1.284-.593 2.37-1.58 3.161l4.444 16.492A20.637 20.637 0 0 0 67.02 45c0-11.455-9.284-20.739-20.739-20.739z",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.281 59.32l1.778-1.778-1.778-6.814-1.778 6.814 1.778 1.778zm-2.271-.099l-.889 3.358 2.074-2.074-1.185-1.284zm4.542 0l-1.185 1.185 2.074 2.074-.889-3.259zm1.679 6.122l-3.95-3.95-3.95 3.95c1.284.198 2.568.395 3.95.395 1.382.001 2.666-.098 3.95-.395zm-3.95-41.082c-11.455 0-20.739 9.283-20.739 20.739 0 9.085 5.826 16.788 13.924 19.553l4.444-16.492c-.988-.691-1.58-1.877-1.58-3.161a3.962 3.962 0 0 1 3.95-3.95 3.962 3.962 0 0 1 3.95 3.95c0 1.284-.593 2.37-1.58 3.161l4.444 16.492A20.637 20.637 0 0 0 67.02 45c0-11.455-9.284-20.739-20.739-20.739z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.81 55.27c-.494.593-1.382.79-2.074.296-.691-.494-.79-1.382-.296-1.975 0 0 2.666-3.555 2.666-8.592s-2.666-8.592-2.666-8.592c-.494-.593-.395-1.481.296-1.975.691-.494 1.58-.296 2.074.296.198.197 3.259 4.246 3.259 10.27S60.008 55.073 59.81 55.27zm-7.208-3.851c-.593-.593-.494-1.679.098-2.271 0 0 1.481-1.58 1.481-4.148S52.7 40.951 52.7 40.852c-.593-.593-.593-1.58-.098-2.271.593-.691 1.481-.691 2.074-.099.098.099 2.468 2.567 2.468 6.518s-2.37 6.419-2.468 6.518c-.593.592-1.482.493-2.074-.099zm-12.642 0c-.593.593-1.481.691-2.074.099-.098-.197-2.468-2.567-2.468-6.518s2.37-6.321 2.468-6.518c.593-.593 1.58-.593 2.074.099.593.593.494 1.679-.098 2.271 0 .099-1.481 1.58-1.481 4.148s1.481 4.148 1.481 4.148c.593.592.691 1.58.098 2.271zm-5.134 4.148c-.691.494-1.58.296-2.074-.296-.198-.197-3.259-4.246-3.259-10.27s3.061-10.073 3.259-10.27c.494-.593 1.382-.79 2.074-.296.691.494.79 1.382.296 1.975 0 0-2.666 3.555-2.666 8.592s2.666 8.592 2.666 8.592c.493.59.296 1.479-.296 1.973z",
  fill: "#FF992E"
}));

function SvgOvercast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "16 15 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercast);
export default __webpack_public_path__ + "static/media/overcast.b9a69fa3.svg";
export { ForwardRef as ReactComponent };